export default __webpack_public_path__ + "static/media/video3.1aa94f86.mp4";